import { Checkbox, FormControlLabel, Grid2 } from "@mui/material";
import { Moment } from "moment";
import { FC, useEffect, useState } from "react";
import { LinesFilter } from "../../../shared/components/filters/LinesFilter";
import {
	EndFilter,
	StartFilter,
} from "../../../shared/components/StartEndFilter";

type Props = {
	onFilterChange: (startDate: Moment, endDate: Moment) => void;
	initialStartDate: Moment;
	initialEndDate: Moment;
	filterLine: number | null;
	onFilterLineChange: (assetId: number | null) => void;
	includeUndeclaredDelays: boolean;
	onIncludeUndeclaredDelaysChange: (include: boolean) => void;
};

export const Filters: FC<Props> = ({
	onFilterChange,
	initialStartDate,
	initialEndDate,
	filterLine,
	onFilterLineChange,
	includeUndeclaredDelays,
	onIncludeUndeclaredDelaysChange,
}) => {
	const [startDate, setStartDate] = useState<Moment>(initialStartDate);
	const [endDate, setEndDate] = useState<Moment>(initialEndDate);

	useEffect(() => {
		setStartDate(initialStartDate);
		setEndDate(initialEndDate);
	}, [initialStartDate, initialEndDate]);

	const handleStartDateChange = (date: Moment | null) => {
		if (date) {
			setStartDate(date);
			onFilterChange(date, endDate);
		}
	};

	const handleEndDateChange = (date: Moment | null) => {
		if (date) {
			setEndDate(date);
			onFilterChange(startDate, date);
		}
	};

	return (
		<Grid2 container alignItems="center" spacing={2}>
			<Grid2 size={{ xs: 12, md: "auto" }}>
				<StartFilter value={startDate} onChange={handleStartDateChange} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: "auto" }}>
				<EndFilter value={endDate} onChange={handleEndDateChange} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: "auto" }} sx={{ minWidth: 180 }}>
				<LinesFilter value={filterLine} onChange={onFilterLineChange} />
			</Grid2>
			<Grid2 size={{ xs: 12, md: "auto" }}>
				<FormControlLabel
					control={
						<Checkbox
							checked={includeUndeclaredDelays}
							color="primary"
							onChange={(e) =>
								onIncludeUndeclaredDelaysChange(e.target.checked)
							}
						/>
					}
					label="Undeclared Delays"
				/>
			</Grid2>
		</Grid2>
	);
};
